import React, { useState, useEffect, useRef } from 'react';
import { NavLink,useNavigate,useNavigation } from 'react-router-dom';
import { Nav } from 'reactstrap';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import firebase from 'firebase';
import PerfectScrollbar from 'perfect-scrollbar';
import PropTypes from 'prop-types';

// Test data
const options = [
  { label: 'Dashboard', value: 'Dashboard' },
  { label: 'User Management', value: 'User_Management' },
  { label: 'Student Management', value: 'Student_Management' },
  { label: 'Book Management', value: 'Book_Management' },
  { label: 'Transaction Management', value: 'Transaction_Management' },
  { label: 'Reports', value: 'Reports' },
  { label: 'Session Management', value: 'Session_Management' },
  { label: 'Subject Management', value: 'Subject_Management' },
];

const sideOptions = [
  'User_Management',
  'Student_Management',
  'Teacher_Management',
  'Batch_Management',
  'Quiz_Management',
  'Session_Management',
  'Book_Management',
  'Subject_Management',
  'Package_Management',
  'Feedback',
  'Enquiry',
  'Chat',
  'Discount_Management',
  'Reports',
  'Notification_Management',
  'Media_Center',
  'Invoice_Management',
];

const Sidebar = ({ bgColor, routes, rtlActive, logo, toggleSidebar }) => {
  const [currentPermission, setCurrentPermission] = useState([]);
  const [isTeacher, setIsTeacher] = useState(false);
  
  const sidebarRef = useRef(null); // Reference to the sidebar for PerfectScrollbar
  const navigate = useNavigate()

  // Active route check function
  const activeRoute = (routeName) => {
    return window.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };

  // Get user data and permissions
  const getUsers = () => {
    // const user = firebase.auth().currentUser;
    // if (!user) {
    //   console.log('No user logged in');
    //   navigate('/login')
    //   return;
    // }
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const uid = user.uid;
        db.collection('zSystemUsers')
          .doc(uid)
          .get()
          .then((querySnapshot) => {
            const data = querySnapshot.data();
            const currentPermissions = sideOptions.filter((item) =>
              data.permissions.find((v) => v.value === item)
            );
            if (data.isTeacher) {
              setIsTeacher(true);
            }
            setCurrentPermission(currentPermissions);
          });
      }
    });
  };

  useEffect(() => {
    // Fetch user permissions on component mount
    getUsers();

    // Initialize PerfectScrollbar for Windows platform
    const ps = new PerfectScrollbar(sidebarRef.current, {
      suppressScrollX: true,
      suppressScrollY: false,
    });

    // Cleanup on unmount
    return () => {
      ps.destroy(); // Properly destroy PerfectScrollbar on unmount
    };
  }, []);

  // Filter the sidebar components based on permissions
  const sidebarComponent = currentPermission.map((data) => {
    return routes.filter((routeData) => data === routeData.id);
  });

  // Logo setup
  let logoImg = null;
  let logoText = null;
  if (logo) {
    if (logo.outterLink) {
      logoImg = (
        <div className='simple-text logo-mini' target='_blank'>
          <div className='logo-img'>
            <img src={logo.imgSrc} alt='react-logo' />
          </div>
        </div>
      );
      logoText = (
        <div className='simple-text logo-normal' target='_blank'>
          {logo.text}
        </div>
      );
    } else {
      logoImg = (
        <div
          to={logo.innerLink}
          className='simple-text logo-mini'
          onClick={toggleSidebar}
          style={{
            transition: 'all 300ms ease 0s',
            opacity: 1,
            float: 'left',
            width: 34,
            textAlign: 'center',
            marginLeft: 12,
            marginRight: 12,
          }}
        >
          <div className='logo-img'>
            <img src={logo.imgSrc} alt='react-logo' />
          </div>
        </div>
      );
      logoText = <div className='simple-text logo-normal'>{logo.text}</div>;
    }
  }

  return (
    <div className='sidebar' data={bgColor}>
      <div className='sidebar-wrapper' ref={sidebarRef}>
        {logoImg || logoText ? (
          <div className='logo'>
            {logoImg}
            {logoText}
          </div>
        ) : null}
        <Nav>
          {sidebarComponent.map((prop, key) => {
            if (prop[0]?.redirect) return null; // Skip if route has redirect
            return (
              <li
                className={
                  activeRoute(prop[0]?.path) +
                  (prop[0]?.pro ? ' active-pro' : '')
                }
                key={key}
              >
                <NavLink
                  to={prop[0]?.layout + '/' + prop[0]?.path}
                  className='nav-link'
                  onClick={toggleSidebar}
                >
                  <i className={prop[0]?.icon} />
                  <p>{rtlActive ? prop[0]?.rtlName :<>
                    {isTeacher ? <>
                      {prop[0]?.name==='Session Management' ? 'Time Table' : prop[0]?.name}
                    </> :prop[0]?.name}
                  </> }</p>
                </NavLink>
              </li>
            );
          })}
          <li className='active-pro'></li>
        </Nav>
      </div>
    </div>
  );
};

Sidebar.defaultProps = {
  rtlActive: false,
  bgColor: 'primary',
  routes: [{}],
};

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  bgColor: PropTypes.oneOf(['primary', 'blue', 'green']),
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    text: PropTypes.node,
    imgSrc: PropTypes.string,
  }),
  toggleSidebar: PropTypes.func,
};

export default Sidebar;
